import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HourglassDisabledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hourglass_disabled"}/>
}
